import { useEffect, useRef, useState } from 'react'
import Header from './Header'
import Sidebar from './Sidebar'
import Drawer from './Drawer'
import { Outlet } from 'react-router-dom'
import '../styles/SiteWrapper.css'
import BottomTabs from './BottomTabs'

const SiteWrapper = () => {
    const [isScrolled, setIsScrolled] = useState(false);
    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 0) {
                setIsScrolled(true);
            } else {
                setIsScrolled(false);
            }
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const drawerRef = useRef<Drawer>(null)
    return (
        <div className="bg-light min-h-screen">
            <aside className='hidden md:flex flex-col md:w-20 lg:w-[240px] fixed'>
                <Sidebar currentRoute='' />
            </aside>
            {/* <Drawer ref={drawerRef} /> */}

            <header className={`max-sm:fixed max-sm:bg-light max-sm:w-full p-5 md:ms-[80px] lg:ms-[240px] z-[998] ${isScrolled ? 'max-sm:shadow-lg' : ''}`}>
                <Header onMenuButtonClick={() => { drawerRef.current?.open() }} />
            </header>

            <main className='min-h-[calc(100vh - 125px)] md:ms-[80px] lg:ms-[240px] px-4 md:px-4 lg:px-6 pb-6 max-sm:pt-[90px]' >
                <Outlet />
            </main>

            <div className={`pt-[85px] md:pt-0`}>
                <BottomTabs />
            </div>

        </div >
    )
}

export default SiteWrapper